import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import installNutUI from './installNut';
import './router/routerPermission';
import { setFirstInUrl } from './utils/util';
import './styles/index.scss';

// todo 生产调试完待移除
// import VConsole from 'vconsole';
// new VConsole();

setFirstInUrl();

const app = createApp(App);
app.use(installNutUI);
app.use(router);
app.use(store);
app.mount('#app');
